import { Injectable } from '@angular/core';
import { TaxwcServicePkg } from './taxwcPkg.service';

@Injectable({
  providedIn: 'root'
})
export class TaxwcService extends TaxwcServicePkg {
  constructor() {
    super();
  }
}
